import React from 'react';
import { isObject } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";

import Authenticated from 'Components/Layouts/Authenticated';
import PageHeader from "Components/Utilities/PageHeader";
import Section from "Components/Utilities/Section";
import CmsElement from 'Components/Utilities/CmsElement';
import QuestionSection from "Components/Utilities/QuestionSection";

import { Loading } from "Components/Partials";
import { getRecordValue } from "Services/CmsHelpers";
import DownloadApi from 'Services/Api/Download/Download';
import { PaginationBar } from "../../Components/Partials";
import { RenderWYSIWYG } from "Components/Form";
import { asset } from "Services/BaseHelpers";


export default class Gallery extends React.Component {
    /**
     * @var headers
     */
    headers = [
        'Mini Gallery',
    ];

    /**
     * @var state
     * @type {{open: string}}
     */
    state = {
        open: 'Mini Gallery',
    };

    /**
     * @method handleToggleSection
     * @param section
     */
    handleToggleSection = (section) => this.setState({
        open: this.state.open === section ? null : section,
    });

    /**
     *
     * @returns {JSX.Element}
     */
    renderOpeningTextSection = () => {
        return (
            <Section>
                <p className="bmw-condenced-bold text-2xl">
                    WHAT’S IN STORE
                </p>

                <p className="bmw-condenced-bold">
                    Please browse through the below galleries to re-live some of the wonderful Cape Town memories.
                </p>
            </Section>
        );
    };

    /**
     * @method render
     * @returns {JSX.Element}
     */
    render() {
        const { working, records, open } = this.state;
        const content = {};
        let carousel = [];
        if (records) {
            records.data
                .filter ( item => getRecordValue ( item, 'type' ).toLowerCase () === 'content' )
                .forEach ( item => {
                    content[ getRecordValue ( item, 'title' ) ] = getRecordValue ( item, 'content' );
                } );
        }
            return (
            <Authenticated>
                <PageHeader
                    imgSrc="headers/gallery.jpg"
                />
                <Section>
                     <>
                        <div className="max-w-6xl mx-auto py-10 px-5 md:px-10">
                            <div className="flex justify-center pb-4">
                                <img
                                    src={ asset('images/mini-logo.png') }
                                    alt="Logo"
                                    className="block w-20 align-self-center"
                                />
                            </div>
                            <div className="text-center">
                                <RenderWYSIWYG
                                    className="text-black"
                                    content={ content['Welcome Text'] ?? '' }
                                />
                            </div>
                        </div>
                    </>
                </Section>
                <Section>
                    { this.headers.map((header, key) => (
                        <div key={`header-${key}`}>
                            <div
                                className="w-full my-auto bmw-condenced-bold flex items-center justify-between cursor-pointer"
                                //onClick={ () => this.handleToggleSection(header) }
                            >
                                {/*<div>{ header }</div>*/}

                                {/*<FontAwesomeIcon*/}
                                {/*    icon={faChevronDown}*/}
                                {/*    className={`transition duration-200 ${open === header ? 'transform rotate-180' : ''}`}*/}
                                {/*/>*/}
                            </div>

                            { open === header && (
                                <GalleryGrid
                                    folder={ header }
                                />
                            ) }
                        </div>
                    )) }
                </Section>

                <QuestionSection/>
            </Authenticated>
        );
    }
}

class GalleryGrid extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'gallery';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = true;

    /**
     * @var state
     */
    state = {
        working: true,
        filters: {
            folder: this.props.folder,
            per_page: 18,
        },
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { working, records } = this.state;

        return (
            <>
                { working && (
                    <Loading/>
                ) }

                { !working && (
                    <>
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 text-left">
                            { records.data?.map(data => (
                                <div key={data.id}>
                                    <img
                                        className="mx-auto my-auto transition duration-200 hover:scale-150"
                                        src={ getRecordValue(data, 'image', 'file') }
                                        decoding="async"
                                    />
                                    <div
                                        onClick={ () => this.handleSubmit(data) }
                                    >
                                        <FontAwesomeIcon
                                            icon={ faDownload }
                                            size="1x"
                                            className={ "mx-1 cursor-pointer" }
                                        />
                                    </div>
                                </div>
                            )) }
                        </div>

                        <div className="mt-5">
                            <PaginationBar
                                total={records.meta.total}
                                pageCount={records.meta.last_page}
                                page={records.meta.current_page}
                                goToPage={this.fetchRecords}
                            />
                        </div>
                    </>
                ) }
            </>
        );
    }

    /**
     * @method handleSubmit
     * @param {object} data
     * @return {Promise<*>}
     */
    handleSubmit = (data) => DownloadApi.download(getRecordValue(data, 'image').value);
}
